import request from '@/utils/request'

/**
 * 获取注册协议列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function getRegisterProtocolList(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/system.listRegisterProtocol',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 更新注册协议
 * @param {Object} data 更新数据
 * @returns {Promise} Promise对象
 */
export function updateRegisterProtocol(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/system.updateRegisterProtocol',
      method: 'post',
      data,
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}